import {Box, Button, Theme, useMediaQuery} from "@material-ui/core";
import {ChevronLeft, ChevronRight} from "react-feather";
import React, {FC, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components/macro";
import {Pagination} from "@material-ui/lab";


const InfoWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  color: #818181;
  font-size: 0.9rem;
  margin-right: 20px;
  b {
    padding: 0 5px;
  }
`

const ButtonsPaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: 10px;
`

const StyledPagination = styled(Pagination)(({ theme }) => ({
  'li:last-child, li:first-child': {
    display: 'none'
  }
}));

const StyledPaginationButton = styled(Button)(({ theme }) => ({
  height: '32px',
  width: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  padding: 0,
  minWidth: '34px',
}));

type PropsType = {
  page: number,
  count: number,
  limit: number,
  onChangePage: (_: any, value: number) => void
}

const PaginationBlock: FC<PropsType> = ({page, count, limit, onChangePage}) => {
  const { t } = useTranslation()
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [currentInterval, setCurrentInterval] = useState({start: 1, end: 5})

  useEffect(() => {
    const result = getCurrentItemsRange(page, count, limit)
    setCurrentInterval(result)
  }, [page, count])

  const getCurrentItemsRange = (currentPage: number, amountElements: number, elementLimit: number) => {
    const result: {start: number, end: number} = {
      start: 1,
      end: amountElements
    }
    if (currentPage * elementLimit - elementLimit !== 0) {
      result.start = currentPage * elementLimit - elementLimit + 1
    }
    if (page * elementLimit <= amountElements) {
      result.end = currentPage * elementLimit
    }
    return {
      start: result.start,
      end: result.end
    }
  }

  const handlerButtons = (button: 'prev' | 'next') => {
    if (button === 'next') {
      if (page < Math.ceil(count / limit)) {
        onChangePage(null, page + 1)
      }
    }
    if (button === 'prev') {
      if (page !== 1) {
        onChangePage(null, page - 1)
      }
    }
  }


  return (
    <Box mt={6} display='flex' flexDirection={sm ? 'column-reverse' : 'row'}>
      <InfoWrapper style={{marginBottom: sm ? '15px' : 0}}>
        {t('showing')} <b>{currentInterval.start}-{currentInterval.end}</b> {t('of')} {count} {t('items')}
      </InfoWrapper>
      <Box display={'flex'} flexDirection={'row'} style={{marginBottom: sm ? '15px' : 0}}>
        <StyledPagination
          variant="outlined"
          size={"medium"}
          count={Math.ceil(count / limit)}
          page={page}
          onChange={onChangePage}
          showFirstButton={false}
          showLastButton={false}
        />
        <ButtonsPaginationWrapper>
          <StyledPaginationButton
            style={{marginRight: '5px'}}
            onClick={() => handlerButtons('prev')}
          >
            <ChevronLeft size={16} color='black'/>
          </StyledPaginationButton>
          <StyledPaginationButton
            onClick={() => handlerButtons('next')}
          >
            <ChevronRight size={16} color='black'/>
          </StyledPaginationButton>
        </ButtonsPaginationWrapper>
      </Box>
    </Box>
  )
}

export default PaginationBlock